import { edited, estimated } from '@fit-editor/fit-core'
import type { EditHistoryState, SummaryValue } from '@fit-editor/fit-core'

/** Ops that rewrite lap/session `totalCalories` as a proportional estimate (calc/boundaries.ts). */
const RESCALING_OPS = new Set(['crop', 'removeInterval', 'deleteRecords'])

/**
 * `computeTotalCalories` reads lap/session totals and can't tell from the
 * Activity alone whether they are still the device's numbers. The history
 * can: the latest active op that touched them decides — a hand edit of a
 * lap/session `totalCalories` makes the value `edited`, a crop /
 * removeInterval / deleteRecords (which rescale totals proportionally)
 * makes it `estimated`.
 */
export function withCaloriesProvenance(
  value: SummaryValue<number>,
  history: EditHistoryState,
): SummaryValue<number> {
  if (value.provenance === 'unavailable' || value.value == null) return value
  const end = Math.min(history.cursor, history.log.length)
  for (let i = end - 1; i >= 0; i--) {
    const op = history.log[i]
    if (op == null) continue
    if (
      op.type === 'editField' &&
      op.field === 'totalCalories' &&
      (op.messagesKey === 'sessionMesgs' || op.messagesKey === 'lapMesgs')
    ) {
      return edited(value.value)
    }
    if (RESCALING_OPS.has(op.type)) return estimated(value.value)
  }
  return value
}
